const SIGN_UP_ACTIONS = {
  SET_SIGN_UP_DETAILS: "SET_SIGN_UP_DETAILS",
};
export default SIGN_UP_ACTIONS;
